import { notification } from "antd";
// @ts-ignore
import commaNumber from "comma-number";
import { Chat, ChatMapping } from "../api/chat/chat-interface";

type NotificationType = "success" | "info" | "warning" | "error";

export const transformAmount = (amount: number) => {
  return commaNumber(amount);
};

export const openNotificationWithIcon = (
  type: NotificationType,
  message: string,
  description: string
) => {
  switch (type) {
    case "success":
      notification.success({
        message,
        description,
      });
      break;
    case "info":
      notification.info({
        message,
        description,
      });
      break;
    case "warning":
      notification.warning({
        message,
        description,
      });
      break;
    case "error":
      notification.warning({
        message,
        description,
      });
      break;
    default:
      break;
  }
};

export const findDashboardRef = (
  refs: {
    belongsTo: string;
    refValue: any;
  }[],
  value: string
) => {
  const checkedRef = refs.filter((item) => item.belongsTo === value);
  if (checkedRef.length > 0) {
    return checkedRef[0].refValue;
  }
  return undefined;
};

/**
 * Gets the difference between two arrays based on name of attribute
 * @param array1 Object
 * @param array2 Object
 * @param name string
 * @returns Object
 */
export const getDifference = (array1: any[], array2: any[], name: string) => {
  return array1.filter((object1) => {
    return !array2.some((object2) => {
      return object1[name] === object2[name];
    });
  });
};

/**
 * Capitalizes the string passed
 * @param value string
 * @returns string
 */
export const capitalizeFirstLetter = (value: string) => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const getHash = (value: string): string => {
  let hash = 0;
  let valueChars = Array.from(value);
  valueChars.forEach((char) => {
    hash = (hash << 5) - hash + char.charCodeAt(0) + Date.now();
    hash = Math.abs(hash & hash);
  });
  return hash.toString(36).slice(-6);
};

export const getOrdinalNumber = (number: number) => {
  if (typeof number !== "number") {
    return number; // Return as-is if not a number
  }

  const lastDigit = number % 10;
  const secondLastDigit = Math.floor((number % 100) / 10);

  if (lastDigit === 1 && secondLastDigit !== 1) {
    return number + "st";
  } else if (lastDigit === 2 && secondLastDigit !== 1) {
    return number + "nd";
  } else if (lastDigit === 3 && secondLastDigit !== 1) {
    return number + "rd";
  } else {
    return number + "th";
  }
};

export const removeOrdinalSuffix = (ordinalString: string) => {
  const numericValue = parseInt(ordinalString, 10);
  if (isNaN(numericValue)) {
    return 0; // Return as-is if not a valid numeric value
  }
  return numericValue;
};

export const queryBuilder = (queryObject: any) => {
  let query: string = "?";
  Object.keys(queryObject).forEach((key) => {
    if (
      queryObject[key] !== "" &&
      queryObject[key] !== " " &&
      queryObject[key] !== "all" &&
      queryObject[key] !== "All" &&
      queryObject[key] !== undefined &&
      queryObject[key] !== null &&
      typeof queryObject[key] !== "object"
    ) {
      query += `${key}=${queryObject[key]}&`;
    }
  });
  return query;
};

const userTypeToMap = {
  student: "Students",
  parent: "Parents",
  teacher: "Teachers",
};

export function sortNewChat(chat: Chat, userId: string):ChatMapping {
  console.log(chat)
  if (chat?.members?.length !== 2) return null;
console.log('sorting')
  const sender = chat.members.find(
    (member) =>
      member?.userId &&
      member?.userId._id !== userId &&
      member.memberType === "user"
  );

  if (!sender || !sender.userId?.userType) return null;

  const { userType } = sender.userId;

  return {
    [userTypeToMap[userType as keyof typeof userTypeToMap]]: chat,
  } as ChatMapping;
}
